/* 
 * Export component file to be used on project
*/

import FloatMenu from './FloatMenu.js';
export default FloatMenu;
